import { render, staticRenderFns } from "./level-box.vue?vue&type=template&id=52a0c233&scoped=true"
import script from "./level-box.vue?vue&type=script&lang=js"
export * from "./level-box.vue?vue&type=script&lang=js"
import style0 from "./level-box.vue?vue&type=style&index=0&id=52a0c233&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a0c233",
  null
  
)

export default component.exports